/* LUXE WORKWEAR — premium motion: scroll reveals + header scroll state. No dependencies. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveals() {
    if (reduce || !('IntersectionObserver' in window)) return;
    var sel = [
      '.lux-hero__inner', '.lux-eyebrow', '.lux-h', '.lux-lead',
      '.lux-prod__media', '.lux-prod__body',
      '.lux-trust__item', '.lux-life__slide',
      '.lux-rev__card', '.lux-cmp__card',
      '.lux-pdp__media', '.lux-pdp__sticky',
      '.lux-page__body', '.lux-page__signoff', '.lux-contact__intro', '.lux-contact__panel'
    ].join(',');
    var els = document.querySelectorAll(sel);
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('lux-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) {
      el.classList.add('lux-reveal');
      io.observe(el);
    });
  }

  function headerState() {
    var update = function () {
      var y = window.scrollY || window.pageYOffset;
      document.documentElement.classList.toggle('lux-scrolled', y > 40);
    };
    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  function init() { reveals(); headerState(); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* === LUXE custom add-to-cart -> Horizon fly-out drawer (no /cart redirect) === */
(function () {
  var LUX_FORM_SEL = '.lux-pdp__form, .lux-prod__form, .lux-upsell__form';
  var ADD_URL = (typeof Theme !== 'undefined' && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';

  function setBusy(form, busy) {
    var btn = form.querySelector('[type="submit"]');
    if (!btn) return;
    if (busy) { btn.dataset.luxLabel = btn.innerHTML; btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.innerHTML = 'Adding…'; }
    else { btn.disabled = false; btn.removeAttribute('aria-busy'); if (btn.dataset.luxLabel != null) { btn.innerHTML = btn.dataset.luxLabel; delete btn.dataset.luxLabel; } }
  }
  function flashError(form, msg) {
    var btn = form.querySelector('[type="submit"]'); if (!btn) return;
    var orig = btn.dataset.luxLabel != null ? btn.dataset.luxLabel : btn.innerHTML;
    btn.innerHTML = msg || 'Unavailable'; setTimeout(function () { btn.innerHTML = orig; }, 1800);
  }
  async function luxAdd(form) {
    var radios = form.querySelectorAll('input[type="radio"][name="id"]');
    if (radios.length && ![].some.call(radios, function (r) { return r.checked; })) {
      var s = form.querySelector('.lux-pdp__sizes'); if (s) s.classList.add('lux-pdp__sizes--needpick');
      flashError(form, 'Select a size'); return;
    }
    var idField = form.querySelector('[name="id"]');
    if (idField && !idField.value) { flashError(form, 'Unavailable'); return; }
    var formData = new FormData(form);
    var sectionIds = [].map.call(document.querySelectorAll('cart-items-component'), function (el) { return el.dataset.sectionId; }).filter(Boolean);
    if (sectionIds.length) formData.append('sections', sectionIds.join(','));
    setBusy(form, true);
    try {
      var res = await fetch(ADD_URL, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'text/html' }, body: formData });
      var data = await res.json();
      if (data.status) { flashError(form, data.description || data.message || 'Sold out'); return; }
      var itemCount = Number(formData.get('quantity')) || 1;
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: data, sourceId: 'lux-custom-form', data: { source: 'product-form-component', itemCount: itemCount, productId: data.product_id, sections: data.sections } } }));
      var drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') {
        var dlg = drawer.querySelector('dialog');
        if (!dlg || !dlg.open) { try { drawer.open(); } catch (e) {} }
      }
    } catch (e) { console.error('LUXE add-to-cart failed', e); flashError(form, 'Try again'); }
    finally { setBusy(form, false); }
  }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest(LUX_FORM_SEL);
    if (!form) return;
    e.preventDefault(); luxAdd(form);
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('input[type="radio"][name="id"]')) {
      var f = e.target.closest('.lux-pdp__form'); if (f) { var s = f.querySelector('.lux-pdp__sizes'); if (s) s.classList.remove('lux-pdp__sizes--needpick'); }
    }
  });
})();
